require('./insuranceRequestDetailsTabsWrapper.scss');
require('./insuranceRequestDetailsTable.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

// @ utilities
const { formatAmount } = require('utilities/currencyHelper');
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;

// @ constants
const { COVERAGES, PLANS } = require('../../insuranceConstants/insuranceRequestHome');
const { EURO_SYMBOL } = require('constants/index');

const CoverageHeaderButtons = props => {
    const {
        plan,
        immInsuranceWizardStep,
        insuranceUsabilityImprovementsFlag,
    } = props;

    const language = getLanguage();

    const planKey = plan.toLowerCase();
    const coverageTabsClasses = classnames('coverages-tabs coverages-details-plans__header', {
        'coverages-details-plans__basic': plan === PLANS.BASIC,
        'coverages-details-plans__basic--color-basic': plan === PLANS.BASIC,
        'coverages-details-plans__medium': plan === PLANS.MEDIUM,
        'coverages-details-plans__medium--color-medium': plan === PLANS.MEDIUM,
        'coverages-details-plans__high': plan === PLANS.HIGH,
        'coverages-details-plans__high--color-high': plan === PLANS.HIGH,
    });
    const planTabClasses = classnames('coverages-tabs__plan-tab', {
        'coverages-tabs__plan-tab--plan-tab-version-1': !insuranceUsabilityImprovementsFlag,
        'coverages-tabs__plan-tab--plan-tab-version-2': insuranceUsabilityImprovementsFlag,
    });
    const totalImport = immInsuranceWizardStep.getIn(['quotationData', planKey, 'totalImport']);
    const tabAmount = `${formatAmount(totalImport, language, 2)} ${EURO_SYMBOL}`;
    const paymentType = immInsuranceWizardStep.getIn(['quotationData', planKey, 'paymentType']);
    const paymentTypeYearly = paymentType ? formatText(`insuranceRequestHome-step3${paymentType.toLowerCase()}Label`) : null;
    
    const getTitlePlanByStoleCoverage = () => {
        const PLANS_ORDERED = [PLANS.BASIC, PLANS.MEDIUM, PLANS.HIGH];
        const coveragePlan = immInsuranceWizardStep.getIn(['coveragesAndPlansData', plan]);
        const coverageItem = coveragePlan.find(item => item.get('name') === COVERAGES.STOLE);
        let id = Number(coverageItem.get('value'));
        return PLANS_ORDERED[id];
    }
    
    const titleDetail = insuranceUsabilityImprovementsFlag ? 
        <FormattedText value={`insuranceRequestHome-insuranceRequestHome_step3${getTitlePlanByStoleCoverage().toLowerCase()}PlanTitleDetail`} className="coverages-tabs__plan coverages-tabs__plan-detail" /> :
        null;

    return (
        <li className={coverageTabsClasses}>
            <label className={planTabClasses} htmlFor={planKey}>
                <div className="coverages-tabs__plan-tab">
                    <FormattedText value={`insuranceRequestHome-step3${planKey}PlanTitle`} className="coverages-tabs__plan" />
                    {titleDetail}
                    <span className="coverages-tabs__plan coverages-tabs__price-items coverages-tabs__price">{tabAmount}</span> 
                    <span className="coverages-tabs__plan coverages-tabs__price-items coverages-tabs__yearly">{paymentTypeYearly}</span>
                </div>
            </label>
        </li>
    );
}

CoverageHeaderButtons.propTypes = {
    immInsuranceWizardStep: PropTypes.object.isRequired,
    insuranceUsabilityImprovementsFlag: PropTypes.bool,
    plan: PropTypes.string.isRequired,
};

module.exports = CoverageHeaderButtons;